import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GRAPH_MARGIN } from 'simInventory/SessionHistory/HistoryAnalysis/HistoryAnalysis.consts';
import { GraphsColorLegend } from 'src/common/components/GraphColorsLegend/GraphColorsLegend';
import { pxToRem } from 'src/common/utils/fonts';

type GraphsBoxProps = {
  title?: React.ReactNode;
  legend?: React.ReactNode;
  leftOffsetPx?: number;
  rightOffsetPx?: number;
  children: React.ReactNode;
  errorMessage?: React.ReactNode;
  colorLegendItems?: { color: string; description: string }[];
};

export const GraphsBox: React.FC<GraphsBoxProps> = ({
  title,
  legend,
  leftOffsetPx = 100,
  rightOffsetPx = 80,
  children,
  errorMessage,
  colorLegendItems,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 2,
          paddingRight: pxToRem(rightOffsetPx),
        }}
      >
        {title ? (
          <Typography
            variant="text3"
            color="text.secondary"
            ml={leftOffsetPx - GRAPH_MARGIN}
            mr={5}
          >
            {title}
          </Typography>
        ) : null}
        <GraphsColorLegend legendItems={colorLegendItems} />
      </Box>
      <Box sx={{ position: 'relative' }}>
        {legend ? (
          <Box
            sx={{
              position: 'absolute',
              width: `${leftOffsetPx - GRAPH_MARGIN}px`,
              inset: 0,
            }}
          >
            {legend}
          </Box>
        ) : null}
        <Box
          sx={{
            ml: pxToRem(leftOffsetPx - GRAPH_MARGIN),
            mr: pxToRem(rightOffsetPx),
            height: '100%',
          }}
        >
          {children}
          {errorMessage && (
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                left: `${leftOffsetPx - GRAPH_MARGIN}px`,
                right: pxToRem(rightOffsetPx),
                height: '100%',
              }}
            >
              {errorMessage}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};
